import React from "react";
import cx from "classnames";

type Props = {
  className?: string;
};

const IconTwitter = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="27"
    className={cx("shareLink shareLink--twitter", className)}
  >
    <path
      fill="#B1B5B6"
      d="M32 3.41a13.14 13.14 0 01-3.77 1.033A6.579 6.579 0 0031.116.811a13.153 13.153 0 01-4.17 1.593 6.546 6.546 0 00-4.79-2.073c-4.239 0-7.354 3.954-6.396 8.06-5.455-.274-10.292-2.887-13.531-6.859a6.574 6.574 0 002.03 8.765 6.527 6.527 0 01-2.971-.821c-.072 3.041 2.108 5.887 5.265 6.52a6.58 6.58 0 01-2.965.112 6.57 6.57 0 006.133 4.559 13.203 13.203 0 01-9.72 2.72 18.59 18.59 0 0010.064 2.949c12.19 0 19.076-10.295 18.66-19.528A13.38 13.38 0 0032 3.409z"
    />
  </svg>
);

export default IconTwitter;
